var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9999 4.25064L14.3287 0H2.6712L0 4.24968C0 5.19936 0.776857 6 1.70037 6C2.62294 6 3.40073 5.25 3.40073 4.24968C3.40073 5.19936 4.17759 6 5.1011 6C6.02367 6 6.80146 5.25 6.80146 4.24968C6.80146 5.19936 7.57832 6 8.50183 6C9.42441 6 10.2022 5.25 10.2022 4.24968C10.2022 5.19936 10.9791 6 11.9026 6C12.8251 6 13.6029 5.25 13.6029 4.24968C13.6029 5.19936 14.3798 6 15.3033 6C16.2231 6 17 5.25 17 4.25062L16.9999 4.25064Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.567 8.28821C14.09 8.28821 13.657 8.19184 13.267 8V11.6503H3.73306V8C3.34306 8.19184 2.91 8.28821 2.43306 8.28821C2.30306 8.28821 2.13 8.28821 2 8.24048V13.5714H14.9992L15 8.23955C14.87 8.28819 14.6969 8.28819 14.5669 8.28819L14.567 8.28821Z",
    fill: "#D8D8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.afbb52e8bd758058805ddef7cb44fee1.svg";
export { ForwardRef as ReactComponent };